module.exports = __webpack_public_path__ + "static/07-fc12ea9c55dc06f36885926be713d06a.jpg";